const Bar = ({ className = '' }: { className?: string }) => (
    <div className={`animate-pulse rounded bg-gray-200 dark:bg-slate-700 ${className}`} />
);

const CollectionAgreementSkeleton = () => (
    <section className="rounded-xl border border-gray-200 bg-white dark:border-slate-700 dark:bg-slate-800">
        <header className="flex flex-wrap items-center justify-between gap-4 border-b border-gray-100 px-5 py-4 dark:border-slate-700">
            <div className="flex items-center gap-3">
                <Bar className="h-6 w-11" />
                <Bar className="h-4 w-24" />
            </div>
            <div className="flex flex-wrap items-center gap-6">
                <Bar className="h-4 w-28" />
                <Bar className="h-6 w-32" />
            </div>
        </header>
        <div className="space-y-6 px-5 py-5">
            <div className="grid grid-cols-1 items-end gap-x-6 gap-y-2 pt-4 md:grid-cols-[minmax(260px,1fr)_2fr]">
                <div className="space-y-2">
                    <Bar className="h-3 w-32" />
                    <Bar className="h-10 w-full" />
                </div>
                <Bar className="h-4 w-3/4" />
            </div>
            <div className="space-y-2">
                {Array.from({ length: 3 }).map((_, index) => (
                    <Bar key={index} className="h-9 w-full" />
                ))}
            </div>
            <div className="space-y-2">
                <Bar className="h-3 w-40" />
                <Bar className="h-20 w-full" />
            </div>
            <div className="space-y-2">
                <Bar className="h-3 w-24" />
                <div className="flex flex-wrap gap-2">
                    {Array.from({ length: 4 }).map((_, index) => (
                        <Bar key={index} className="h-7 w-40" />
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default CollectionAgreementSkeleton;
